import React from "react";
import cn from "classnames";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Card from "../../../components/Card";
import styles from "./PopularDecksReal.module.sass";

const emojiFor = (title) => {
  if (!title) return "📘";
  const s = title.toLowerCase();
  if (/negocio|business|trabajo|work/.test(s)) return "💼";
  if (/medic|medical|salud|health/.test(s)) return "🩺";
  if (/emoc|feel|mood/.test(s)) return "🙂";
  if (/financ|econom|money/.test(s)) return "💹";
  if (/travel|viaj|world|word/.test(s)) return "🌍";
  if (/hsk[- ]?1|beginner|inicial/.test(s)) return "🌱";
  if (/hsk[- ]?5|advanced|avanz/.test(s)) return "🎯";
  return "📘";
};

const PopularDecksReal = ({ className }) => {
  const { t } = useTranslation();
  const { value, isLoading, error } = useSelector((s) => s.stats.popularDecks);
  const items = value?.results ?? [];
  const maxMetric = items.reduce((m, it) => Math.max(m, it.metric || 0), 0);
  return (
    <Card
      className={cn(styles.card, className)}
      title={t("home.popularDecks.title", "Decks populares")}
      classTitle="title-blue"
    >
      <div className={styles.list}>
        <div className={styles.head}>{t("home.popularDecks.deck", "Deck")}</div>
        {isLoading && <div className={styles.state}>{t("home.popularDecks.loading", "Cargando…")}</div>}
        {error && <div className={styles.state}>{t("home.popularDecks.error", "No se pudo cargar")}</div>}
        {!isLoading && !error && items.length === 0 && (
          <div className={styles.state}>{t("home.popularDecks.empty", "Sin datos aún")}</div>
        )}
        {items.map((it, i) => (
          <Link key={it._id} to={`/deck/edit/${it._id}`} className={styles.row}>
            <div className={cn(styles.rank, { [styles.rankTop]: i === 0 })}>{i + 1}</div>
            <div className={styles.avatar}>
              {it.avatarUrl ? (
                <img src={it.avatarUrl} alt="" />
              ) : (
                <span>{emojiFor(it.title)}</span>
              )}
            </div>
            <div className={styles.info}>
              <div className={styles.title}>{it.title || t("home.popularDecks.untitled", "Sin título")}</div>
              <div className={styles.meta}>
                {it.metric?.toLocaleString("es-ES")} {t("home.popularDecks.plays", "partidas")}
              </div>
              {maxMetric > 0 && (
                <div className={styles.bar}>
                  <span
                    className={styles.barFill}
                    style={{ width: `${Math.max(6, Math.round(((it.metric || 0) / maxMetric) * 100))}%` }}
                  />
                </div>
              )}
            </div>
          </Link>
        ))}
      </div>
      <Link to="/catalog?type=deck" className={cn("button-stroke", styles.footer)}>
        {t("home.popularDecks.viewAll", "Ver catálogo de decks")}
      </Link>
    </Card>
  );
};

export default PopularDecksReal;
